import { getHistoryState, updateHistoryState } from '@/utils/historyState'
import { mixpanelLog } from './mixpanel'
import mixpanel from 'mixpanel-browser'
import { mixpanelToken } from '@/utils/runtime'
import { getSource } from './saveSource'

type LogEventTo = 'ga' | 'mixpanel'

interface LogEventProps {
  eventName: string
  properties?: Record<string, any>
  to?: LogEventTo[]
  withSource?: boolean
  once?: boolean
}

interface UserProperties {
  id: string
  account_type: 'advertiser' | 'youtuber'
  organization_name: string | undefined
  // TODO : 유저 프로퍼티값 추가
  // sign_up_date: string
  // agree_terms: string
  // visit_count: number
  // campaign_count: number
  // active_campaign_count: number
  // collection_count: number
}

export const initLoggingEnvironment = () => {
  mixpanel.init(mixpanelToken)
}

export const identifyUser = (userProperties: UserProperties) => {
  const info = mixpanel.get_property('id')

  if (info && info.id === userProperties.id) return

  mixpanel.identify(userProperties.id)
  mixpanel.people.set(userProperties)
}

export const logEvent = ({
  eventName,
  properties,
  to = ['mixpanel'],
  withSource = false,
  once = false,
}: LogEventProps) => {
  const source = withSource ? getSource() : null

  const eventProperties = {
    ...properties,
  }

  // 이미 로깅된 값인지 확인할때는 source 값을 포함하지 않음. (source는 유입 경로를 파악하기 위한 값이기 때문에)
  // 관련 코멘트 : https://github.com/leesh312/collable-next/pull/20#discussion_r2014098482
  const historyKey = `${eventName}-${JSON.stringify(properties)}`
  const isLogged = getHistoryState()?.[historyKey]

  if (once && isLogged) return
  if (source) eventProperties.source = source

  if (to.includes('mixpanel')) {
    mixpanelLog(eventName, eventProperties)
  }

  if (once) updateHistoryState({ [historyKey]: true })
}
